import { HttpRequest } from '../../lib/http';
import { API } from './constant';

export const getCity = (term: string) => {
  return HttpRequest({
    method: API.CITY.TYPE,
    url: API.CITY.URL(term),
  });
};
